export default "__VITE_ASSET__Cy$N9770__"